import './program-carousel.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { useEffect, useState } from 'react';
import { useHistory }         from 'react-router-dom';
import MovieCard              from '../../card/movie-card/movie-card';
import { render_object_type } from '../../../shared/services/general/configs';
import SeriesCard             from '../../card/series-card/series-card';
import Slider from 'react-slick-pnth';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

function ProgramCarousel ({ data, type, style = 'one' }) {
	const history = useHistory();
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
	const [innerWidth, setInnerWidth] = useState(window.innerWidth);
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 767);
			setInnerWidth(window.innerWidth)
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const items = data?.programs?.length ? data.programs : data?.objects || [];
	const itemsLength = items.length;

	const settings = {
		dots: false,
		// infinite: itemsLength >= 7,
		slidesToShow: itemsLength >= 8 ? 7.8 : itemsLength,
		// slidesToShow: 7,
		slidesToScroll: itemsLength >= itemsLength / 2 ? 7.8 : itemsLength > 1 ? itemsLength - 1: itemsLength,
		arrows: false,
		infinite : false,
		// variableWidth: true,
		initialSlide: 0,
		currentSlide: 0,
		rtl: true,
		responsive: [
			{
				breakpoint: 1600,
				settings: {
					slidesToShow: itemsLength >= 10 ? 9.5 : itemsLength,
				}
			},
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: itemsLength >= 8 ? 7.8 : itemsLength,
				}
			},
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: itemsLength >= 6 ? 6 : itemsLength,
					arrows: false
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: itemsLength >= 6 ? 5.5 : itemsLength,
					arrows: false
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3.4,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 430,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 380,
				settings: {
					slidesToShow: 2.9,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 350,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			}
		],
	};

	const goToDeepLink = () => {
		history.push(data.deepLink);
	};

	const genre_name = (genre_name) => {
		localStorage.setItem('gname', genre_name);
	}

	const sortedDataObjects = items.sort((a, b) => a.order - b.order);

	return (
		<>
			<div style={{overflow: 'hidden'}}>
				{
					sortedDataObjects && sortedDataObjects.length > 0 && (
						<div className="carousel program-carousel">
							{
								style === 'one' ? (
									<div className="carousel-header">
										<div onClick={() => {
											goToDeepLink();
											genre_name(data.title);
										}}>
											<span>{data.title === '???' ? 'سریال' : data.title}</span>
											{data.title !== 'فیلم‌های مشابه' && data.title !== 'سریال‌های مشابه' && data?.deepLink && (
												<span><ChevronLeftIcon style={{ color: "white", fontSize: '30px' }} /></span>)}
										</div>
									</div>
								)  : style === 'two' ? (
									<div className="main-title">
										<div onClick={() => {
											goToDeepLink();
											genre_name(data.title);
										}}>
											<span className="title">{data.title === '???' ? 'سریال' : data.title}</span>
											{data.title !== 'فیلم‌های مشابه' && data.title !== 'سریال‌های مشابه' && data?.deepLink && (
												<span><ChevronLeftIcon style={{ color: "white", fontSize: '30px' }} /></span>)}
										</div>
									</div>
								) : (
									<div className="carousel-header">
										<div onClick={() => {
											goToDeepLink();
											genre_name(data.title);
										}}>
											<span>{data.title === '???' ? 'سریال' : data.title}</span>
											{data.title !== 'فیلم‌های مشابه' && data.title !== 'سریال‌های مشابه' && data?.deepLink && (
												<span><ChevronLeftIcon style={{ color: "white" }} /></span>)}
										</div>


									</div>
								)
							}
							<div className="carousel-body rtl-slider">
								{data && (
									<Slider {...settings}
											className={sortedDataObjects.length < 7 ? 'single-slide-container' : ''}>
										{sortedDataObjects.map((value, index) => {
											const key = `${value.id || value.programId}-${index}`;
											if (type === render_object_type.movie) {
												return <MovieCard key={key} data={value} />;
											} else if (type.toLowerCase() === render_object_type.series.toLowerCase()) {
												return <SeriesCard key={key} data={value} />;
											} else {
												return null;
											}
										})}
									</Slider>
								)}

							</div>
						</div>
					)
				}
			</div>
		</>

	);
}

export default ProgramCarousel;
